export const RequiredAsterisk: React.FC = () => {
    return <span className="required-asterisk">*</span>
}